import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./component/Home";
import OrderOnline from "./component/OrderOnline/OrderOnline";
import Checkout from "./component/OrderOnline/checkout/Checkout";
import CartProvider from "./cartprovider/CartProvider";
import LoaderProvider from "./loaderprovider/LoaderProvider";
import ToastProvider from "./toastprovider/ToastProvider";
import TimeProvider from "./timeprovider/TimeProvider";

function App() {
  return (
    <div>
      <TimeProvider>
        <LoaderProvider>
          <ToastProvider>
            <CartProvider>
              <Router>
                <Switch>
                  <Route exact path="/">
                    <Home />
                  </Route>
                  <Route path="/order">
                    <OrderOnline />
                  </Route>
                  <Route exact path="/checkout">
                    <Checkout />
                  </Route>
                </Switch>
              </Router>
            </CartProvider>
          </ToastProvider>
        </LoaderProvider>
      </TimeProvider>
    </div>
  );
}

export default App;
